import React, { useState } from "react";
import "../../../../../ApiCalls/mantisFlowsManangment";
import { Button } from "../../../../components/ui/button";
import { ChevronDown, ChevronUp, Eye } from "lucide-react";
import { useToast } from "../../../../components/ui/use-toast";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../../components/ui/table";
import "../../../../components/ui/badge";
import "../../components/CommentsSection";
import "../../Utils/utils";
import PurchaseOrderDetailsModal from "./components/PurchaseOrderDetailsModal";

export const PurchaseOrderSection = ({
  data,
  addLog,
  selectedSupplierId,
  onSupplierSelect,
  quotationItems = [],
  isLoadingQuotationItems,
  onStepChange,
  purchaseOrders,
  mantisBusiness,
}) => {
  useState(null);
  useState(null);
  useState(true);
  useToast();
  const [expandedPO, setExpandedPO] = useState(null);
  const [selectedPO, setSelectedPO] = useState(null);
  const [showPODetailsModal, setShowPODetailsModal] = useState(false);

  const toggleExpand = (poId) => {
    setExpandedPO(expandedPO === poId ? null : poId);
  };

  const handlePOClick = (po) => {
    setSelectedPO(po);
    setShowPODetailsModal(true);
  };

  // Función para renderizar el contenido de PO Creation
  const renderPOCreatedContent = () => {
    return (
      <div className="p-3 overflow-auto h-full">
        <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 shadow-sm">
          <div className="p-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80">
            <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200 flex items-center">
              Purchase Orders
            </h3>
          </div>
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead></TableHead>
                  <TableHead>PO Number</TableHead>
                  <TableHead>Supplier</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Created At</TableHead>
                  <TableHead>Currency</TableHead>
                  <TableHead className="text-right">Total Amount</TableHead>
                  <TableHead className="text-center">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {purchaseOrders.map((po) => (
                  <React.Fragment key={po.po_number || po.id}>
                    <TableRow className="hover:bg-slate-50 dark:hover:bg-slate-700/50 cursor-pointer">
                      <TableCell>
                        <button
                          onClick={() => toggleExpand(po.po_number || po.id)}
                        >
                          {expandedPO === (po.po_number || po.id) ? (
                            <ChevronUp />
                          ) : (
                            <ChevronDown />
                          )}
                        </button>
                      </TableCell>
                      <TableCell
                        onClick={() => handlePOClick(po)}
                        className="cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {po.po_number || po.id}
                      </TableCell>
                      <TableCell
                        onClick={() => handlePOClick(po)}
                        className="cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {po.supplier_name}
                      </TableCell>
                      <TableCell
                        onClick={() => handlePOClick(po)}
                        className="cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {po.status}
                      </TableCell>
                      <TableCell
                        onClick={() => handlePOClick(po)}
                        className="cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {po.created_at?.slice(0, 10)}
                      </TableCell>
                      <TableCell
                        onClick={() => handlePOClick(po)}
                        className="cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {po.currency}
                      </TableCell>
                      <TableCell
                        onClick={() => handlePOClick(po)}
                        className="text-right font-medium cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {po.currency}{" "}
                        {Number(po.total_amount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                      </TableCell>
                      <TableCell className="text-center">
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handlePOClick(po)}
                          className="h-8 w-8 p-0 hover:bg-blue-100 dark:hover:bg-blue-900/20"
                        >
                          <Eye className="h-4 w-4 text-blue-600 dark:text-blue-400" />
                        </Button>
                      </TableCell>
                    </TableRow>
                    {expandedPO === (po.po_number || po.id) && (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          className="bg-slate-50 dark:bg-slate-900/40"
                        >
                          <div className="p-2">
                            <h4 className="font-semibold mb-2 text-slate-700 dark:text-slate-200">
                              Items
                            </h4>
                            <Table>
                              <TableHeader>
                                <TableRow>
                                  <TableHead>#</TableHead>
                                  <TableHead>Name</TableHead>
                                  <TableHead>Delivery Time (days)</TableHead>
                                  <TableHead>Quantity</TableHead>
                                  <TableHead>Unit</TableHead>
                                  <TableHead>Unit Price</TableHead>
                                  <TableHead>Total Price</TableHead>
                                </TableRow>
                              </TableHeader>
                              <TableBody>
                                {po.items?.map((item, idx) => (
                                  <TableRow key={item.id || idx}>
                                    <TableCell>{idx + 1}</TableCell>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>
                                      {item.delivery_time_days}
                                    </TableCell>
                                    <TableCell>{item.quantity}</TableCell>
                                    <TableCell>{item.unit}</TableCell>
                                    <TableCell>
                                      {po.currency}{" "}
                                      {Number(item.unit_price).toLocaleString(
                                        undefined,
                                        { minimumFractionDigits: 2 }
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {po.currency}{" "}
                                      {Number(item.total_price).toLocaleString(
                                        undefined,
                                        { minimumFractionDigits: 2 }
                                      )}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderPOCreatedContent()}
      <PurchaseOrderDetailsModal
        open={showPODetailsModal}
        onClose={() => setShowPODetailsModal(false)}
        purchaseOrder={selectedPO}
        purchaseOrderItems={selectedPO?.items || []}
        mantisBusiness={mantisBusiness}
        data={data}
      />
    </div>
  );
};

export default PurchaseOrderSection;

